var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plug"},[_vm._v(" Please turn the device over ")])
}
var staticRenderFns = []

export { render, staticRenderFns }